import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import useQueryParams from "../../useQueryParams";
import { omitEmptyValuesProp } from "../../../utils/index";
import { apiUrl, per_page_default, total_pages_header, wc_orders } from "../../../config/config";

// /wp-json/wc/v3/Orders?search=ABC123&category=cat1&per_page=10

export const useGetOrders = (params = {}) => {
  const queryParams = useQueryParams();

  const productParams = omitEmptyValuesProp({
    search: queryParams.params.search,
    status: queryParams.params.status,
    state: queryParams.params.state,

    page: queryParams.params.page || "1",
    per_page: `${per_page_default}`,
    ...params,
  });

  const fn = async () => {
    const { data, headers } = await axios.get(`${apiUrl}/${wc_orders}`, { params: productParams });
    const totalPages = headers?.[total_pages_header];
    return {
      totalPages,
      list: data,
    };
  };
  return useQuery([wc_orders, productParams], fn);
};
